import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const FootprintsIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5 4a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M7 6c.6 0 1 .4 1 1v10a1 1 0 1 1-2 0V7c0-.6.4-1 1-1Zm4 0c.6 0 1 .4 1 1v10a1 1 0 1 1-2 0V7c0-.6.4-1 1-1Zm3.8 0a1 1 0 0 1 1.2.8l2 10a1 1 0 1 1-2 .4l-2-10a1 1 0 0 1 .8-1.2Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default FootprintsIcon;
